import script from "./avatarView.vue?vue&type=script&setup=true&lang=ts"
export * from "./avatarView.vue?vue&type=script&setup=true&lang=ts"

import "./avatarView.vue?vue&type=style&index=0&id=05778850&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05778850"]])

export default __exports__